import classNames from 'classnames';
import { ContentDataBlockAttachment } from '@amf/shared/components/content/Content';

export function calculateFileSize(size: number): string {
  const i = Math.floor(Math.log(size) / Math.log(1024));
  return (
    ((size / Math.pow(1024, i)).toFixed(2) as any) * 1 + ' ' + ['B', 'kB', 'MB', 'GB', 'TB'][i]
  );
}

export function getFileIconName(type: string): string {
  switch (type) {
    case 'docx':
      return 'bi-file-earmark-word';

    case 'xls':
    case 'xlsx':
      return 'bi-file-earmark-spreadsheet';

    case 'ppt':
    case 'pptx':
      return 'bi-file-easel';

    case 'zip':
    case 'rar':
      return 'bi-file-earmark-zip';

    case 'png':
    case 'jpg':
    case 'jpeg':
    case 'gif':
    case 'svg':
      return 'bi-file-earmark-image';

    case 'pdf':
      return 'bi-file-earmark-pdf';

    default:
      return 'bi-file-earmark';
  }
}

interface AttachmentProps {
  block: ContentDataBlockAttachment;
}

export default function Attachment({ block }: AttachmentProps) {
  return (
    <a href={block.data.file.url} download className='Content__attachment'>
      <i
        className={classNames(
          getFileIconName(block.data.file.extension),
          'Content__attachmentIcon',
        )}
      />
      <div className='Content__attachmentContent'>
        <div className='Content__attachmentTitle'>{block.data.title}</div>
        <div className='Content__attachmentSize'>{calculateFileSize(block.data.file.size)}</div>
      </div>
      <i className='Content__attachmentIcon bi-download' />
    </a>
  );
}
